import { ChatSummary } from '../model/chat-summary.model';

export function filterSummaryByKeyword(
    keyWord: string | null,
    categories: ChatSummary[],
): ChatSummary[] {
    if (keyWord == null || keyWord.trim().length === 0) {
        return [...categories];
    }

    return categories.filter((c) =>
        (c?.name ?? '').toLowerCase().includes(keyWord),
    );
}
